var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-button',{on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('v-icon',{attrs:{"color":"grey"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }